module.exports = __webpack_public_path__ + "img/BTT.156d2344.svg";